import { Button } from '@/components/ui/button';
import { routerPaths } from '@/routers/router-paths';
import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router';

export default function ErrorBoundaryFallBack() {
  const error = useRouteError();
  const navigate = useNavigate();

  if (isRouteErrorResponse(error)) {
    return (
      <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
        <div className="p-8 text-center">
          <p className="text-lg mt-2">
            {error.status} {error.statusText}
          </p>
          {error.data?.message && <p className="text-sm mt-1">{error.data.message}</p>}
          <Button
            className="mt-2"
            onClick={() => navigate(routerPaths.root)}
          >
            Go to Home
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="p-8 text-center">
      <h1 className="text-3xl font-bold">Unexpected Error</h1>
      <p className="text-sm mt-2 text-red-500">{(error as Error).message}</p>
    </div>
  );
}
